// @flow
type Props = {
  className?: string,
  fill?: ?string,
};

export const SemiCircleWindowDevice = ({
  className,
  fill = "#0A4254",
}: Props) => {
  return (
    <svg
      viewBox="0 0 439 220"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>semi-circle-inverse</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-2" stroke={fill} strokeWidth="2">
        <path
          d="M439,0 L439,220 L433.814614,220 C435.202492,220.003747 436.533631,219.44837 437.508702,218.458737 C438.483772,217.469104 439.020926,216.128284 439,214.737786 C436.20964,95.6646981 338.990349,0 219.5,0 C99.996271,0 2.79036035,95.6646981 0,214.737786 C-0.0209261771,216.128284 0.516228215,217.469104 1.49129843,218.458737 C2.46636865,219.44837 3.79750809,220.003747 5.18538554,220 L0,220 L0,0 L439,0 Z"
          id="semi-circle-inverse"
          fill={fill}
        ></path>
      </g>
    </svg>
  );
};
